export const convertSecondsToHours = (seconds: number) => {
  const hours = (seconds / 3600).toFixed(1);

  // Remove trailing zero if it's a whole number
  return hours.endsWith(".0") ? hours.slice(0, -2) : hours;
};

export const convertMinutesToHours = (minutes: number) => {
  const hours = (minutes / 60).toFixed(1);

  // Remove trailing zero if it's a whole number
  return hours.endsWith(".0") ? hours.slice(0, -2) : hours;
};

export const convertMinuteStringToTotalMinutes = (minuteString: string) => {
  const [hours, minutes] = minuteString.split(":");
  return Number(hours) * 60 + Number(minutes);
};

export const convertTotalMinutesToMinutesString = (totalMinutes: number) => {
  // 750 -> 12:30
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}:${minutes}`;
};

export const formatTimeString = (timeString: string) => {
  if (!timeString) return "";

  // If already in HH:MM format, return as is
  if (typeof timeString === "string" && timeString.includes(":"))
    return timeString;

  // Convert to number for calculations
  const totalMinutes = parseInt(timeString);

  // Calculate hours and minutes
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  // Format with leading zeros
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}`;
};
